import "./ProfileMenu.css";

import React, { useRef } from "react";

import { OrganisationTypeConstants } from "../../../constants";
import { useAuth } from "../../../useAuth";
import { useClickOutside } from "../../../utils";
import { useScroll } from "../../../utils/hooks/useScroll";

interface ProfileMenuProps {
  show: boolean;
  onClose: () => void;
  children: React.ReactNode;
  position?: { top?: string; right?: string; bottom?: string; left?: string };
  closeOnScroll?: boolean;
  corners?: "rounded" | "default";
}

export const ProfileMenu = ({
  show,
  onClose,
  position,
  children,
  closeOnScroll = false,
  corners = "default",
}: ProfileMenuProps): JSX.Element | null => {
  const { currentUserType } = useAuth();
  const wrapperRef = useRef(null);
  useClickOutside(wrapperRef, () => {
    onClose();
  });

  if (closeOnScroll)
    useScroll(() => {
      onClose();
    });

  return show ? (
    <div ref={wrapperRef} className="ProfileMenuWrapper">
      <div
        className={`ProfileMenuContainer ${
          currentUserType === OrganisationTypeConstants.ASSET_MANAGER ? "rounded" : corners
        }`}
        style={{ ...position }}
      >
        {children}
      </div>
    </div>
  ) : null;
};
